<template>
    <div class="basemsg-box">
        <div class="flex flex-y-center mb-56">
            <div class="progress-tit">档案完成度{{ baseData.rate }}%</div>
            <van-progress class="progress" stroke-width="10px" color="#2FD0D5" :show-pivot="false" :percentage="baseData.rate" />
        </div>
        <div class="line flex flex-y-center mb-56">
            <div :class="`circle ${baseData.birthDate ? 'already' : ''}`"></div>
            <div class="msg-tit">生日：</div>
            <div class="flex flex-y-center" @click="showBirthdayPopup">
                <input v-model="baseData.birthDate" class="input" type="text" disabled="true" placeholder="请输入"
                    placeholder-style="color:#999999" />
            </div>
            <van-icon class="arrow" name="arrow" color="#a0acb5" />
        </div>
        <div class="line flex flex-y-center mb-56">
            <div :class="`circle ${baseData.gender ? 'already' : ''}`"></div>
            <div class="msg-tit">性别：</div>
            <div class="flex flex-y-center">
                <div :class="`change-btn ${baseData.gender == 1 ? 'active' : ''}`" @click="changeSex(1)">
                    女
                </div>
                <div :class="`change-btn ${baseData.gender == 2 ? 'active' : ''}`" @click="changeSex(2)">
                    男
                </div>
            </div>
        </div>
        <div class="line flex flex-y-center mb-56">
            <div :class="`circle ${baseData.idCard ? 'already' : ''}`"></div>
            <div class="msg-tit">身份证号：</div>
            <input class="input" v-model="baseData.resIdCard" @input="onIdCardInput()" type="text" placeholder="请输入"
                placeholder-style="color:#999999" />
        </div>
        <div class="line flex flex-y-center mb-56">
            <div :class="`circle ${baseData.isMarry == 1 || baseData.isMarry == 0 ? 'already' : ''}`"></div>
            <div class="msg-tit">婚姻状况：</div>
            <div class="flex flex-y-center">
                <div :class="`change-btn ${baseData.isMarry == 1 ? 'active' : ''}`" @click="changeMarriage(1)">
                    已婚
                </div>
                <div :class="`change-btn ${baseData.isMarry == 0 ? 'active' : ''}`" @click="changeMarriage(0)">
                    未婚
                </div>
            </div>
        </div>
        <div class="line flex flex-y-center mb-56">
            <div :class="`circle ${baseData.fertilityStatus ? 'already' : ''}`"></div>
            <div class="msg-tit">生育状况：</div>
            <div class="flex flex-y-center" @click="showChildPopup">
                <input class="input" v-model="baseData.fertilityStatus" type="text" disabled="true" placeholder="点击选择"
                    placeholder-style="color:#999999" />
            </div>
            <van-icon class="arrow" name="arrow" color="#a0acb5" />
        </div>
        <div class="line flex flex-y-center mb-56">
            <div :class="`circle ${baseData.companyType ? 'already' : ''}`"></div>
            <div class="msg-tit">公司类型：</div>
            <div class="flex flex-y-center" @click="showCompanyPopup">
                <input class="input" v-model="baseData.companyType" type="text" disabled="true" placeholder="点击选择"
                    placeholder-style="color:#999999" />
            </div>
            <van-icon class="arrow" name="arrow" color="#a0acb5" />
        </div>
        <div class="line flex flex-y-center mb-56">
            <div :class="`circle ${baseData.fromName ? 'already' : ''}`"></div>
            <div class="msg-tit">来源渠道：</div>
            <div class="flex flex-y-center" @click="showSourcePopup">
                <input class="input" v-model="baseData.fromName" type="text" disabled="true" placeholder="点击选择"
                    placeholder-style="color:#999999" />
            </div>
            <van-icon class="arrow" name="arrow" color="#a0acb5" />
        </div>
        <div class="line flex flex-y-center mb-106">
            <div :class="`circle ${baseData.income ? 'already' : ''}`"></div>
            <div class="msg-tit">年收入：</div>
            <div class="flex flex-y-center" @click="showIncomePopup">
                <input class="input" v-model="baseData.income" type="text" disabled="true" placeholder="点击选择"
                    placeholder-style="color:#999999" />
            </div>
            <van-icon class="arrow" name="arrow" color="#a0acb5" />
        </div>
        <div class="flex flex-x-center">
            <button class="save-btn" @click="saveBase">保存</button>
        </div>
        <!-- 生日选择器 -->
        <van-popup v-model="showBirthday" position="bottom" custom-style="height: 40%;" @click-overlay="closeBirthdayPopup">
            <van-datetime-picker type="date" v-model="baseData.birthday" @confirm="onBirthConfirm" @cancel="onBirthCancel"
                :min-date="minDate" :max-date="maxDate" :formatter="formatter" />
        </van-popup>
        <!-- 生育状况选择器 -->
        <van-popup v-model="showChild" position="bottom" custom-style="height: 40%;" @click-overlay="closeChildPopup">
            <van-picker show-toolbar @confirm="onChildConfirm" @cancel="onChildCancel" :columns="fertilityColumns" />
        </van-popup>
        <!-- 公司类型选择器 -->
        <van-popup v-model="showCompany" position="bottom" custom-style="height: 40%;" @click-overlay="closeCompanyPopup">
            <van-picker show-toolbar @confirm="onCompanyConfirm" @cancel="onCompanyCancel" :columns="companyColumns" />
        </van-popup>
        <!-- 来源选择器 -->
        <van-popup v-model="showSource" position="bottom" custom-style="height: 40%;" @click-overlay="closeSourcePopup">
            <van-picker show-toolbar @confirm="onSourceConfirm" @cancel="onSourceCancel" :columns="sourceColumns" />
        </van-popup>
        <!-- 收入选择器 -->
        <van-popup v-model="showIncome" position="bottom" custom-style="height: 40%;" @click-overlay="closeIncomePopup">
            <van-picker show-toolbar @confirm="onIncomeConfirm" @cancel="onIncomeCancel" :columns="incomeColumns" />
        </van-popup>
    </div>
</template>

<script>
import * as com from "../../../utils/util.js";

export default {
    props: {
        baseData: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    data() {
        return {
            showBirthday: false, // 生日弹框
            minDate: new Date(1940, 0, 1), // 生日最小可选
            maxDate: new Date(), // 生日最大可选
            formatter(type, value) {
                // 生日选项格式化函数
                if (type === "year") {
                    return `${value}年`;
                }
                if (type === "month") {
                    return `${value}月`;
                }
                return value;
            },
            columns: ["杭州", "宁波", "温州", "嘉兴", "湖州"],
            fertilityColumns: ["未婚", "已婚未育", "已婚已育"], //生育选项
            companyColumns: [
                "党政机关单位/政府部门",
                "公立医院",
                "公立教育机构（大学及中小学）",
                "国有企业",
                "外资/合资企业",
                "私营企业",
                "个体工商户/经营户/电商平台店主/农村种植养殖大户",
                "自由职业者（如独立创作者、职业股民、自媒体从业者等从事脑力劳动的个人）",
                "农村外出务工人员",
                "普通农民（主要以务农为主）",
            ], //公司选项
            sourceColumns: [
                "团购",
                "直播",
                "社群、公众号分销",
                "自然步入",
                "老带新",
                "银行",
                "再邀约",
                "地推、沙龙",
                "商场、异业合作",
                "其他第三方平台",
            ], //来源选项
            incomeColumns: [
                "12w以下",
                "12-36w",
                "36-72w",
                "72-120w",
                "120-240w",
                "240w以上",
            ], //收入选项
            showChild: false, //生育弹框
            showCompany: false, //公司弹框
            showSource: false, //来源弹框
            showIncome: false, //收入弹框
            default: {
                source: 0,
                child: 0,
                income: 0,
                company: 0,
            },
        };
    },
    methods: {
        // 保存基础信息
        saveBase() {
            this.$emit('onBaseSave', this.baseData)
        },
        // 生日弹框
        setPopupShow(key, value) {
            this[key] = value;
        },
        showBirthdayPopup() {
            this.setPopupShow("showBirthday", true);
        },
        closeBirthdayPopup() {
            this.setPopupShow("showBirthday", false);
        },
        onBirthCancel(event) {
            this.setPopupShow("showBirthday", false);
        },
        onBirthConfirm(event) {
            this.baseData.birthday = event;
            this.baseData.birthDate = com.timeFormat(event);
            this.setPopupShow("showBirthday", false);
        },
        // 选择性别
        changeSex(sex) {
            this.baseData.gender = sex;
        },
        // 身份证号
        onIdCardInput(e) {
            this.baseData.idCard = this.baseData.resIdCard;
        },
        // 婚姻选择
        changeMarriage(num) {
            this.baseData.isMarry = num;
        },
        // 生育选择
        showChildPopup() {
            this.setPopupShow("showChild", true);
        },
        closeChildPopup() {
            this.setPopupShow("showChild", false);
        },
        onChildCancel(event) {
            this.setPopupShow("showChild", false);
        },
        onChildConfirm(event) {
            let child = event;
            this.baseData.fertilityStatus = child;
            this.setPopupShow("showChild", false);
        },
        // 公司选择
        showCompanyPopup() {
            this.setPopupShow("showCompany", true);
        },
        closeCompanyPopup() {
            this.setPopupShow("showCompany", false);
        },
        onCompanyCancel() {
            this.setPopupShow("showCompany", false);
        },
        onCompanyConfirm(event) {
            let company = event;
            (this.baseData.companyType = company),
                this.setPopupShow("showCompany", false);
        },
        //来源选择
        showSourcePopup() {
            this.setPopupShow("showSource", true);
        },
        closeSourcePopup() {
            this.setPopupShow("showSource", false);
        },
        onSourceCancel() {
            this.setPopupShow("showSource", false);
        },
        onSourceConfirm(event) {
            let source = event;
            this.baseData.fromName = source
            this.setPopupShow("showSource", false);
        },
        // 收入选择
        showIncomePopup() {
            this.setPopupShow("showIncome", true);
        },
        closeIncomePopup() {
            this.setPopupShow("showIncome", false);
        },
        onIncomeCancel() {
            this.setPopupShow("showIncome", false);
        },
        onIncomeConfirm(event) {
            let income = event;
            this.baseData.income = income
            this.setPopupShow("showIncome", false);
        },
    },
};
</script>

<style lang="less" scoped>
.mb-56 {
    margin-bottom: 56px;
}
.basemsg-box {
    width: 100%;
    padding: 30px 30px;
}

.progress-tit {
    min-width: 158px;
    font-size: 24px;
    color: #2fd0d5;
    margin-right: 20px;
}
.progress {
    flex: 1;
}
.line {
    position: relative;
}
.input {
    width: 485px;
    height: 70px;
    border-radius: 6px;
    border: 1px solid #999999;
    padding: 0 30px;
    box-sizing: border-box;
    line-height: 70px;
    font-size: 28px;
    margin-left: 2px;
}
.circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: 22px;
    background: #d8d8d8;
}
.circle.already {
    background: #333f48;
}
.msg-tit {
    width: 158px;
    font-size: 28px;
    color: #35434c;
}
.arrow {
    position: absolute;
    right: 35px;
    top: 22px;
    width: 16px;
    height: 28px;
    font-size: 28px;
}
.change-btn {
    width: 150px;
    height: 60px;
    background: #f2f3f7;
    border-radius: 30px;
    margin-right: 30px;
    text-align: center;
    color: #a0acb5;
    font-size: 28px;
    line-height: 60px;
}
.change-btn.active {
    background: #2fd0d5;
    color: #fff;
}
.save-btn {
    width: 520px !important;
    height: 90px;
    background: #333f48;
    border-radius: 45px;
    color: #ffffff;
    font-size: 30px;
    line-height: 90px;
    padding: 0;
    margin-top: 50px;
    overflow: hidden;
    margin-bottom: 55px;
}
:deep(input:disabled, input[disabled]) {
    color: #333f48;
    opacity: 1;
    -webkit-text-fill-color: #333f48; // ios 和 安卓9.0 必须添加此属性，才会生效
    -webkit-opacity: 1;
    background-color: transparent;
}
</style>
